import 'whatwg-fetch';
import BasicAuthSettings from './basic_auth_settings';

export default class Session {
  constructor(authSettings = null, baseUrl = 'http://127.0.0.1', apiAppendix = '/api/v1') {
    this._apiAppendix = apiAppendix;

    this._authSettings = authSettings || new BasicAuthSettings();

    // var defaults = {};
    // this.RestService = RestService || require('isomorphic-fetch');
    // defaults.username = _authSettings.getUsername();
    // defaults.password = _authSettings.getPassword();
    // restService = new this.RestService.Service(defaults);
    // restService = fetch;
    //
    this._baseUrl = baseUrl;
    this.status = undefined;
    this.wasError = undefined;
  }

  set authSettings(authSettings) {
    this._authSettings = authSettings;
  }

  get authSettings() {
    return this._authSettings;
  }

  get baseUrl() {
    return this._baseUrl;
  }

  getPath(path) {
    return this.baseUrl + this._apiAppendix + path;
  }

  handleErrors(response) {
    if (!response.ok) {
      throw Error(response.status + ': ' + response.statusText);
    }
    return response;
  }

  /**
   * Checks if a network request came back fine, and throws an error if not
   *
   * @param  {object} response   A response from a network request
   *
   * @return {object|undefined} Returns either the response, or throws an error
   **/
  checkStatus(response) {
    this.status = response.status;
    this.wasError = response.status < 200 || response.status >= 300;
    return response;
  }

  /**
   * Parses the JSON returned by a network request
   *
   * @param  {object} response A response from a network request
   *
   * @return {object}          The parsed JSON from the request
   */
  parseJSON(response) {
    if (response.status === 204 || response.status === 205) {
      return null;
    }

    return response.json();
  }

  checkErrors(response) {
    if (this.wasError) {
      throw new Error(JSON.stringify([this.status, response]));
    } else {
      return response;
    }
  }

  handleResponse(responsePromise, callback = undefined) {
    let result;

    if (callback !== undefined) {
      responsePromise.then(this.checkStatus.bind(this))
        .then(this.parseJSON.bind(this))
        .then(this.checkErrors.bind(this))
        .then(callback);
    } else {
      result = responsePromise.then(this.checkStatus.bind(this))
        .then(this.parseJSON.bind(this))
        .then(this.checkErrors.bind(this));
    }
    return result;
  }

  getHeaders() {
  // const headers = new Headers();

  // headers.append('Accept', 'application/json');
  // headers.append('Content-Type', 'application/json');

    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    this.authSettings.authenticateHeader(headers);
    return headers;
  }

  get(path, params, callback) {
    const result = fetch(this.getPath(path), {
      method: 'GET',
      headers: this.getHeaders()
    });

    return this.handleResponse(result, callback);
  }

  post(path, params, callback) {
    const result = fetch(this.getPath(path), {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(params)
    });

    return this.handleResponse(result, callback);
  }

  delete(path, params, callback) {
    const result = fetch(this.getPath(path), {
      method: 'DELETE',
      headers: this.getHeaders()
    });

    return this.handleResponse(result, callback);
  }

  patch(path, params, callback) {
    const result = fetch(this.getPath(path), {
      method: 'PATCH',
      headers: this.getHeaders(),
      body: JSON.stringify(params)
    });

    return this.handleResponse(result, callback);
  }

  put(path, params, callback) {
    const result = fetch(this.getPath(path), {
      method: 'PUT',
      headers: this.getHeaders(),
      body: JSON.stringify(params)
    });

    return this.handleResponse(result, callback);
  }
}
